var map = {
	"./0.png": "8d84",
	"./1.png": "c1c5",
	"./2.png": "81e5",
	"./Map_Pin.png": "73af",
	"./app-store.png": "89a7",
	"./call-ic.svg": "ee6f",
	"./card1.svg": "1607",
	"./card2.svg": "4451",
	"./confirmed-icn.svg": "021c",
	"./deonde-icon.svg": "710d",
	"./deonde-poweredby.svg": "53a3",
	"./discount.png": "8864",
	"./empty_cart.png": "d96b",
	"./food-dish.jpg": "052d",
	"./google-play.png": "c4cb",
	"./gps-ic.svg": "0dbc",
	"./gps.png": "30dc",
	"./gps.svg": "42f0",
	"./gps1.png": "2b68",
	"./icon_delivery_marker.png": "290c",
	"./icon_store_marker.png": "5a3a",
	"./login.svg": "d625",
	"./logo-placeholder-image.png": "cd9b",
	"./logo-white.svg": "a266",
	"./logo.svg": "e347",
	"./map.png": "8708",
	"./map1.png": "947a",
	"./no-time-slot.svg": "58d8",
	"./no_address_found.png": "aa37",
	"./no_item.png": "30f9",
	"./no_promocode.png": "55b6",
	"./no_promocode.svg": "6e03",
	"./no_search.png": "082f",
	"./no_store.png": "a3b2",
	"./non_veg.png": "5096",
	"./offer-ic.svg": "00f5",
	"./place_holder.png": "bd0e",
	"./sellingh.jpg": "18bd",
	"./shop-icon.png": "9018",
	"./support-icon.svg": "6b9a",
	"./support.png": "a884",
	"./whatsapp-icon.png": "5608"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";